<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.logradouro"
        ref="RkmDataTable"
    >
        <template v-slot:cell(logradouro_cep)="row">
            {{row.value | cep}}
        </template>
    </rkm-data-table>
</template>

<script>
// Formats.
import format from '@/utils/format'

export default {
    computed: {
        fields() {
            return [
                {key: 'pais_nome', label: 'País', name: 'cadastro_pais.nome', searchable: true, sortable: true},
                {key: 'estado_nome', label: 'Estado', name: 'cadastro_estado.nome', searchable: true, sortable: true},
                {key: 'estado_uf', label: 'Sigla', name: 'cadastro_estado.uf', searchable: true, sortable: true},
                {key: 'municipio_nome', label: 'Município', name: 'cadastro_municipio.nome', searchable: true, sortable: true},
                {key: 'municipio_ibge', label: 'IBGE', name: 'cadastro_municipio.ibge', searchable: true, sortable: true},
                {key: 'bairro_nome', label: 'Bairro', name: 'cadastro_bairro.nome', searchable: true, sortable: true},
                {key: 'logradouro_tipo_nome', label: 'Tipo', name: 'cadastro_logradouro_tipo.nome', searchable: true, sortable: true},
                {key: 'logradouro_nome', label: 'Nome', name: 'cadastro_logradouro.nome', searchable: true, sortable: true},
                {key: 'logradouro_cep', label: 'CEP', name: 'cadastro_logradouro.cep'},
            ]
        },
    },
    filters: {
        cep: format.cep,
    },
    inject: ['repositories'],
}
</script>